'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './document-edit.routes.js';

export class DocumentEditComponent {
  /*@ngInject*/
  constructor(dialogs, DocumentService, $stateParams, $state, $location, Config, StorageService) {
    this.baseContainerClass = Config.getPlatformConfig().getBaseContainerClass();
    this.DocumentService = DocumentService;
    this.StorageService = StorageService;
    this.docId = $stateParams.id;
    this.dialogs = dialogs;
    this.$state = $state;
    this.$location = $location;

    var documentConfig = Config.getModuleConfig(Config.Modules.Document);

    this.pageTitle = Config.getPageTitleByStateWithDefault($state.current.name, "Document Upload");

    // Enumeration with possible document types
    this.documentType = documentConfig.getTypes();

    this.documentPageCategories = documentConfig.getPageCategories();
    this.defaultPermissionByType = documentConfig.getDefaultPermissionByType();

    this.permissionModel = {};
    this.roles = Config.getPlatformConfig().getPermissionRoles();

    this.document = {};

    this.DocumentService.get({id: this.docId}, doc => {
      this.document = doc;

      this.StorageService.getMeta({id: this.document.document}, docMeta => {
        this.roles.forEach(role => {
          this.permissionModel[role] = docMeta.permission.includes(role);
        });
      });
    }, err => {
      console.log('Could not get the document from the server.');
    });

    this.submitted = false;
  }

  typeChanged() {
    let type = this.document.type;
    if (this.defaultPermissionByType[type]) {
      let defaultRoles = angular.isArray(this.defaultPermissionByType[type])
        ? this.defaultPermissionByType[type]
        : [this.defaultPermissionByType[type]];
      this.roles.forEach(role => {
        this.permissionModel[role] = defaultRoles.includes(role);
      })
    }
  }

  patch(form) {

    this.submitted = true;
    this.sendSuccess = false;
    this.sendFailure = false;

    var that = this;

    if (form.$valid) {
      this.DocumentService.update({id: this.docId}, this.document, () => {
          this.submitted = false;
          this.sendSuccess = true;

          let permission = [];

          if (!this.document.isPublic) {
            for (let role in this.permissionModel) {
              if (this.permissionModel.hasOwnProperty(role)) {
                if (this.permissionModel[role] === true){
                  permission.push(role);
                }
              }
            }
          }

          this.StorageService.update({id: this.document.document}, {permission:permission}, _ => {
            var dlg = this.dialogs.notify("Success", "Your document has been changed successfully");
            dlg.result.then(() => {

              let docPageType = "list";

              if (that.documentPageCategories) {
                for (let key in that.documentPageCategories) {
                  if (that.documentPageCategories.hasOwnProperty(key)) {
                    if (that.documentPageCategories[key].indexOf(that.document.type) != -1) {
                      docPageType = key;
                    }
                  }
                }
              }

              that.$location.url("/document/"+docPageType);
            });
          });

        },
        (err) => {
          this.sendFailure = true;
        })
    }
  }

  cancel() {
    let docPageType = "list";

    if (this.documentPageCategories) {
      for (let key in this.documentPageCategories) {
        if (this.documentPageCategories.hasOwnProperty(key)) {
          if (this.documentPageCategories[key].indexOf(this.document.type) != -1) {
            docPageType = key;
          }
        }
      }
    }

    this.$location.url("/document/"+docPageType);
  }
}

export default angular.module('conduuApp.documentEdit', [uiRouter])
  .config(routes)
  .component('documentEdit', {
    template: require('./document-edit.html'),
    controller: DocumentEditComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/document/edit/document-edit.component.js